import { AppointmentStore } from "./types";

export const defaultState: AppointmentStore = {
  appointment: {
    type: "JOB",
  },
  loading: false,
};
